import { patchUserPassword } from '@api';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreUsersByIdPasswordPatchAsyncSlice = createPatchAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.PASSWORD_UPDATED),
			type: SagaYieldType.Every
		}
	],
	name: 'CoreUsersByIdPassword',
	receive: false,
	request: true,
	requestHandler: patchUserPassword
});
